<template>
  <template-info
    title="คำถามที่พบบ่อย
เกี่ยวกับ Vat"
  >
    <div>
      <div class="wrap-list">
        <span><img :src="QUESTION" alt="question1" /></span>
        <span class="contents bold">
          ภาษีมูลค่าเพิ่มจดเมื่อไหร่?
        </span>
      </div>
      <div class="wrap-list margin-bottom">
        <span><img :src="ANSWER" alt="answer1" /></span>
        <span class="contents">
          เมื่อมีรายได้ถึง 1.8 ล้านบาทในระหว่างปี ถ้าปีไหนถึงเกณฑ์นี้
          แปลว่าเรามีภาระหน้าที่ต้อง จดทะเบียนภาษีมูลค่าเพิ่มทันที
          และมีความต้องการใช้ภาษีซื้อเพื่อมาหักจากยอดภาษีขาย
        </span>
      </div>

      <div class="wrap-list">
        <span><img :src="QUESTION" alt="question2" /></span>
        <span class="contents bold">
          รายได้ 1.8 ล้านบาทนี้ หมายถึงรายได้จาก อะไรบ้าง?
        </span>
      </div>
      <div class="wrap-list margin-bottom">
        <span><img :src="ANSWER" alt="answer2" /></span>
        <span class="contents">
          หลักการของภาษีมูลค่าเพิ่ม<br />จะมีรายได้ 2 ประเภท<br />
          1. รายได้ที่ได้รับยกเว้นภาษีมูลค่าเพิ่ม<br />
          2. รายได้ที่ต้องเสียภาษีมูลค่าเพิ่ม การนับยอด 1.8 ล้านบาท
          จะนับเมื่อมีรายได้ที่ต้องเสียภาษีมูลค่าเพิ่ม รวมแล้วเกิน 1.8 ล้านบาท
          โดยไม่นับยอดของรายได้ที่ได้รับยกเว้น
        </span>
      </div>
      <div class="wrap-list">
        <span><img :src="QUESTION" alt="question3" /></span>
        <span class="contents bold">
          บุคคลธรรมดาต้องจดทะเบียน ภาษีมูลค่าเพิ่มไหม?
        </span>
      </div>
      <div class="wrap-list margin-bottom">
        <span><img :src="ANSWER" alt="answer3" /></span>
        <span class="contents">
          ภาษีมูลค่าเพิ่ม จะมองตามการประกอบการ ของผู้ประกอบการรายนั้นๆ
          โดยไม่ได้สนใจรูป แบบของธุรกิจ ดังนั้นไม่ว่าจะเป็น
          บุคคลธรรมดาหรือนิติบุคคลก็มีหน้าที่ จดทะเบียนภาษีมูลค่าเพิ่ม
          เมื่อมีรายได้ ถึงเกณฑ์ที่กฎหมายกำหนด
        </span>
      </div>
      <div class="wrap-list">
        <span><img :src="QUESTION" alt="question3" /></span>
        <span class="contents bold">
          มีรายได้ประจำ รายได้เสริม รวมกันไหม? ต้องคิดยังไง?
        </span>
      </div>
      <div class="wrap-list margin-bottom">
        <span><img :src="ANSWER" alt="answer3" /></span>
        <span class="contents">
          ถ้ารายได้ที่ต้องเสียภาษีมูลค่าเพิ่มรวมกันแล้ว ถึง 1.8 ล้านบาท
          แบบนี้ก็ต้องจดทะเบียน ภาษีมูลค่าเพิ่มให้ถูกต้อง
        </span>
      </div>
    </div>
  </template-info>
</template>

<script>
import QUESTION from "@/assets/images/infos/question.png";
import ANSWER from "@/assets/images/infos/answer.png";
export default {
  name: "ProsCons",
  components: {},
  data() {
    return {
      QUESTION,
      ANSWER,
    };
  },
  methods: {
    goChangeProcess() {
      this.$router.push({ path: "/info/change_process" });
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
.contents {
  margin-left: 17px;
}
.title {
  margin-bottom: 8px;
}
.margin-bottom {
  margin-bottom: 35px;
}
.wrap-list {
  display: flex;
  margin-top: 15px;
}
.red {
  color: #f45a49;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
}
</style>
